import * as Yup from "yup"
import {calculateAge} from "../../utility/calculateDateAndAge"

export const getPermitValidationSchema = (t, payOneTime) => payOneTime ? Yup.mixed() : Yup.mixed().when("permit_type", {is: (permit_type:string) => permit_type === "C Permit" || permit_type === "B Permit", then: Yup.mixed().required(t("required"))})
export const getSecondAddressValidationSchema = (t, payOneTime) => payOneTime < 0 ? Yup.mixed() : Yup.mixed().when("onShipAddress", {is: (onShipAddress:boolean) => onShipAddress, then: Yup.mixed().required(t("required"))})

export const getCheckoutSchema = (t, payOneTime) => {
	const secondAddressValidation = getSecondAddressValidationSchema(t, payOneTime)
	const permitValidation = getPermitValidationSchema(t, payOneTime)
	return Yup.object().shape({
		firstname: Yup.string()
			.min(2, "Too Short!")
			.max(50, "Too Long!")
			.required(t("required")),
		lastname: Yup.string()
			.min(2, "Too Short!")
			.max(50, "Too Long!")
			.required(t("required")),
		email: Yup.string()
			.email("Invalid email")
			.required(t("required")),
		gender: Yup.string()
			.required(t("required")),
		contract_type: Yup.string()
			.required(t("required")),
		permit_type: Yup.string()
			.required(t("required")),
		date_of_entry: payOneTime ? Yup.string() : Yup.string().when("permit_type", {is: ["C Permit", "B Permit"], then: Yup.string().required(t("required"))}),
		permit_valid_until: payOneTime ? Yup.string() : Yup.string().when("permit_type", {is: ["C Permit", "B Permit"], then: Yup.string().required(t("required"))}),
		country_choice: permitValidation,
		phone: Yup.number()
			.required(t("required")),
		prefix: Yup.string()
			.required(t("required")),
		date_of_birth: payOneTime ? Yup.string() : Yup.string()
			.required("Bist du sicher, dass dies dein korrektes Geburtsdatum ist?")
			.test("age-validation", "Du musst mindestens 18 Jahre alt sein.", value => value !== undefined && calculateAge(value, "/") >= 18),
		street: Yup.string()
			.required(t("required")),
		street_number: Yup.string()
			.required(t("required")),
		city: Yup.string()
			.required(t("required")),
		zip: Yup.string()
			.required(t("required")),
		onShipAddress: Yup.boolean(),
		secondary_address_street: secondAddressValidation,
		secondary_address_street_number: secondAddressValidation,
		secondary_address_city: secondAddressValidation,
		secondary_address_zip: secondAddressValidation,
		language_selected: Yup.string()
			.required(t("required")),
		all_agb: Yup.string().oneOf(["true"]).required(t("required")),
		date_of_birth_month: payOneTime ? Yup.string() : Yup.string().required(t("required")),
		date_of_birth_day: payOneTime ? Yup.number() : Yup.number().max(31).min(1).required(t("required")),
		date_of_birth_year: payOneTime ? Yup.number() : Yup.number().max(9999).min(1900).required(t("required")),
		permit_valid_until_month: permitValidation,
		permit_valid_until_day: permitValidation,
		permit_valid_until_year: permitValidation,
		date_of_entry_month: permitValidation,
		date_of_entry_day: permitValidation,
		date_of_entry_year: permitValidation,
		firebase_contact_uid: Yup.string()
	})
}

export const getPayOneTimeCheckoutSchema = (t, payOneTime) => {
	const secondAddressValidation = getSecondAddressValidationSchema(t, payOneTime)
	return Yup.object().shape({
		firstname: Yup.string()
			.min(2, "Too Short!")
			.max(50, "Too Long!")
			.required(t("required")),
		lastname: Yup.string()
			.min(2, "Too Short!")
			.max(50, "Too Long!")
			.required(t("required")),
		email: Yup.string()
			.email("Invalid email")
			.required(t("required")),
		gender: Yup.string()
			.required(t("required")),
		phone: Yup.number()
			.required(t("required")),
		prefix: Yup.string()
			.required(t("required")),
		street: Yup.string()
			.required(t("required")),
		street_number: Yup.string()
			.required(t("required")),
		city: Yup.string()
			.required(t("required")),
		zip: Yup.string()
			.required(t("required")),
		onShipAddress: Yup.boolean(),
		secondary_address_street: secondAddressValidation,
		secondary_address_street_number: secondAddressValidation,
		secondary_address_city: secondAddressValidation,
		secondary_address_zip: secondAddressValidation,
		language_selected: Yup.string()
			.required(t("required")),
		all_agb: Yup.string().oneOf(["true"]).required(t("required")),
		firebase_contact_uid: Yup.string()
	})
}
